export const environment = {
  production: false,
  apiUrl: "https://examenes.test.teamhakkyo.com.ar/server/api"
};
